import { render, staticRenderFns } from "./ingresos_caja.vue?vue&type=template&id=63389fea&"
import script from "./ingresos_caja.vue?vue&type=script&lang=js&"
export * from "./ingresos_caja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports